let rangeSliders = {};

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());
}

function updatePriceInput(values) {
    const min = parseInt($('.js-range-price').attr('data-min')),
        max = parseInt($('.js-range-price').attr('data-max')),
        fromValue = values[0] || parseInt($('input[name="filter[price][from]"]').val()),
        toValue = values[1] || parseInt($('input[name="filter[price][to]"]').val()),
        priceFormat = wNumb({
            decimals: 0,
            suffix: Eshop.options.currency.symbol_right
        });

    if (fromValue === min && toValue === max) {
        $(this).val('').removeAttr('value');
        $('input[name="filter[price][from]"]').val('').removeAttr('value');
        $('input[name="filter[price][to]"]').val('').removeAttr('value');
    } else {
        if (values[0] !== null) {
            $('input[name="filter[price][from]"]').val(priceFormat.to(parseInt(values[0])));
        }

        if (values[1] !== null) {
            $('input[name="filter[price][to]"]').val(priceFormat.to(parseInt(values[1])));
        }
    }

    if (rangeSliders['price']) {
        rangeSliders['price'].set([values[0], values[1]]);
    }
}

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from),
        $to = $(selectors.to),
        fromVal = $from.val(),
        toVal = $to.val(),
        minValue = sliderInstance.options.range.min[0],
        maxValue = sliderInstance.options.range.max[0],
        valuesFrom = parseInt(values[0]),
        valuesTo = parseInt(values[1]);

    if (minValue == valuesFrom && maxValue == valuesTo) {
        $from.val('').removeAttr('value');
        $to.val('').removeAttr('value');

        Filter.submit();

        return true;
    }

    $from.val(values[0]);
    $to.val(values[1]);

    Filter.submit();
}

function createRangeSliders() {
    $('.js-range-price').each(function () {
        const $elem = $(this),
            $slider = $elem.find('.range-slider__slider'),
            tooltipSuffix = Eshop.options.currency.symbol_right,
            maxValue = Number($elem.attr('data-max')),
            minValue = Number($elem.attr('data-min')),
            fromValue = Number($elem.attr('data-from')),
            toValue = Number($elem.attr('data-to'));

        rangeSliders['price'] = noUiSlider.create($slider[0], {
            start: [fromValue, toValue],
            range: {
                'min': [minValue],
                'max': [maxValue]
            },
            margin: 1,
            connect: true,
            tooltips: [
                wNumb({
                    decimals: 0,
                    suffix: '<span class="suffix">' + tooltipSuffix + '</span>'
                }),
                wNumb({
                    decimals: 0,
                    suffix: '<span class="suffix">' + tooltipSuffix + '</span>'
                })
            ],
            format: wNumb({
                decimals: 0,
                suffix: tooltipSuffix
            }),
            step: 1
        });

        rangeSliders['price'].on('change', function (values, handle) {
            updateRangeCallback({
                from: '[name="filter[price][from]"]',
                to: '[name="filter[price][to]"]'
            }, values, this);
        });
    });
}

function updateFilterBubbles() {
    if ($('.js-filter-bubbles-item').length < 1) {
        $('.js-filter-bubbles-reset').remove();
    }
}

Event.on("Filter.reset", function() {
    const min = parseInt($('.js-range-price').attr('data-min')),
        max = parseInt($('.js-range-price').attr('data-max'));

    updatePriceInput([min, max]);
});


$(function () {
    createRangeSliders();

    $('body').on('change', '.filter__form [type="checkbox"]', function() {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function() {
        setTimeout(function() {
            updateFilterBubbles();
        }, 1);
    });

    $('body').on('click', '.js-filter-bubbles-reset', function(e) {
        Filter.reset();
        updateFilterBubbles();
    });

    $('.js-filter-close, .js-filter-submit').on('click', function() {
        $('.filter-parameters__item .js-tabs-trigger.is-active').trigger('click');
        $('.catalog-filter').removeClass('has-active-filter');
        $('body').css('overflow', '');

        // unfreezeScroll();

        $('.catalog__products').slideHere();
    });

    $('.js-trigger-filter').on('click', function () {
        $('.catalog-filter').addClass('has-active-filter');
        $('body').css('overflow', 'hidden')

        if ($('.filter-parameters__item .js-tabs-trigger.is-active').length < 1) {
            $('.filter-parameters__item:first-child .js-tabs-trigger').trigger('click');
        }

        // freezeScroll();
    });

    $('body').on('click', '.pager__item a', function () {
        $('.catalog__products').slideHere(60);
    });

    $('input[name="filter[price][from]"], input[name="filter[price][to]"]').on('focus', function() {
        const $input = $(this),
            value = $input.val();

        if (value) {
            $input.val(parseInt(value)).select();
        }
    });

    $('input[name="filter[price][from]"]').on('blur change', function() {
        const min = parseInt($('.js-range-price').attr('data-min')),
            max = parseInt($('.js-range-price').attr('data-max')),
            toValue = parseInt($('input[name="filter[price][to]"]').val());

        let value = parseInt($(this).val()),
            newVal = false;

        if (isNaN(value)) {
            newVal = min;
        }
        else if (value > toValue) {
            newVal = toValue - 1;
        }
        else if (value < min) {
            newVal = min;
        }
        else if (value > max) {
            newVal = max - 1;
        }

        if (newVal) {
            $(this).val(newVal);
            value = newVal;
        }

        if (isNaN(toValue)) {
            if (newVal === min) {
                $(this).val('').removeAttr('value');
            }
            else {
                updatePriceInput([value, max]);
            }
        } else {
            updatePriceInput([value, null]);
        }
    });

    $('input[name="filter[price][to]"]').on('blur change', function() {
        const min = parseInt($('.js-range-price').attr('data-min')),
            max = parseInt($('.js-range-price').attr('data-max')),
            fromValue = parseInt($('input[name="filter[price][from]"]').val());

        let value = parseInt($(this).val()),
            newVal = false;

        if (isNaN(value)) {
            newVal = max;
        }
        else if (value < fromValue) {
            newVal = fromValue + 1;
        }
        else if (value < min) {
            newVal = min + 1;
        }
        else if (value > max) {
            newVal = max;
        }

        if (newVal) {
            $(this).val(newVal);
            value = newVal;
        }

        if (isNaN(fromValue)) {
            if (newVal === max) {
                $(this).val('').removeAttr('value');
            }
            else {
                updatePriceInput([min, value]);
            }
        } else {
            updatePriceInput([null, value]);
        }
    });

    $('.js-filter-search').each(function() {
        const $searchInput = $(this).find('.c-form__input');

        $searchInput.on('change keyup', function() {
            const $input = $(this),
                $list = $input.parents('.filter-content__options').find('.filter-options');

            $list.find('.filter-options__item').each(function() {
                const inputValue = $input.val().normalize('NFKD').replace(/[\u0300-\u036f]/g, "").toUpperCase(),
                    itemValue = $(this).find('.c-form__input').attr('placeholder').normalize('NFKD').replace(/[\u0300-\u036f]/g, "").toUpperCase();

                if (itemValue.indexOf(inputValue) > -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });
    });
});
